module.exports = __webpack_public_path__ + "img/reparation-de-robinet.bd757021.jpg";